import React, { useContext, useEffect, useState, useRef } from 'react'
import { jwtDecode } from "jwt-decode"
import { NormasContext } from '../../context/NormasContext'
import Arrow from "../../assets/img/arrow2.svg"
import "./Muestras.scss"
import ModalNewMuestra from '../../components/Modales/Normas/ModalNewMuestra'
import ModalEditMuestra from '../../components/Modales/Normas/ModalEditMuestra'
import ModalVerificarMuestra from '../../components/Modales/Normas/ModalVerificarMuestra'
// ui
import { Modal } from "react-bootstrap"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Oval } from 'react-loader-spinner'

const API_URL = process.env.REACT_APP_API_URL;

export const muestraContext = React.createContext()

const Muestras = ({ idSubtarea, tieneMuestras }) => {

    const auth = localStorage.getItem("token")
    const jwtParse = jwtDecode(auth)
    const user = jwtParse.apirest.objeto

    const { 
        status,
        muestras, 
        fetchMuestras 
    } = useContext(NormasContext)

    const dataMuestras = muestras[idSubtarea] || []

    const [open, setOpen] = useState(false)
    const [modal, setModal] = useState(false)

    const [modalText, setModalText] = useState(false)
    const [textSelected, setTextSelected] = useState(null)

    const [tipo, setTipo] = useState(null)

    const [modalEditMuestra, setModalEditMuestra] = useState(false)
    const [objMuestra, setObjMuestra] = useState(null)

    const [modalVerificar, setModalVerificar] = useState(false)
    const [idVerificar, setIdVerificar] = useState(null)

    const menuRef = useRef();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if(idSubtarea){
            fetchMuestras({
                idsubtarea: idSubtarea
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idSubtarea])

    // MODAL NEW MUESTRA
    const handleModal = (t) => {
        setTipo(t)
        setModal(true)
        setOpen(false)
    }

    // MODAL TEXTO LARGO
    const handleClose = () => setModalText(false);

    const showText = (id) => {
        const texto = dataMuestras.find(e => e.id_muestra_norma === id)
        setTextSelected(texto.descripcion)
        setModalText(true)
    }

    // VERIFICAR MUESTRA
    const showModalVerificar = (id) => {
        setIdVerificar(id)
        setModalVerificar(true)
    }

    // EDITAR MUESTRA
    const editarMuestra = (id) => {
        const obj = dataMuestras.find((e) => e.id_muestra_norma === id)
        setObjMuestra(obj)
        setModalEditMuestra(true)
    }

    return (
        <>
            <muestraContext.Provider value={{ user, tipo, idSubtarea, objMuestra, idVerificar }}>
                {/* VER MUESTRA DE TIPO TEXTO */}
                <Modal show={modalText} onHide={handleClose} centered backdrop="static" animation={false} >
                    <Modal.Header>
                        <Modal.Title className='d-flex flex-row justify-content-between'>
                            <h3 className='m-0 text-blue-500'>Texto largo</h3>
                            <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body><p>{textSelected}</p></Modal.Body>
                </Modal>
                {/* MODAL CREAR MUESTRA */}
                <ModalNewMuestra show={modal} onHide={()=>setModal(false)} animation={false} dialogClassName="custom-fade-modal" />
                {/* MODAL EDITAR MUESTRA */}
                <ModalEditMuestra show={modalEditMuestra} onHide={()=>setModalEditMuestra(false)} animation={false} dialogClassName="custom-fade-modal" />
                {/* MODAL VERIFICAR MUESTRA */}
                <ModalVerificarMuestra show={modalVerificar} onHide={()=>setModalVerificar(false)} animation={false} dialogClassName="custom-fade-modal" />
                <div className='muestras'>
                    {status.muestras.loading ? (
                        <div className='loading__muestras d-flex flex-row align-items-center justify-content-center'>
                            <Oval
                                visible={true}
                                height="40"
                                width="40"
                                color="#0d6efd"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                            <p className='m-0 fw-medium'>Loading...</p>
                        </div>
                    ) : (
                        <>
                            {status.muestras.error ? (
                                <div className='muestras--error d-flex flex-column align-items-center'>
                                    <p className='text-danger fw-medium'><i className="bi bi-exclamation-circle me-1"></i> {status.muestras.error}</p>
                                </div>
                            ) : (
                                <>
                                    {tieneMuestras === true && <>
                                        {dataMuestras.length === 0 ? (
                                            <div className='muestras--empty'>
                                                <div className='d-flex flew-row mb-2'>
                                                    <img className='arrow me-2' src={Arrow} alt='' />
                                                    <span className='fst-italic m-0 p-0 text-secondary'>Sin evidencias registradas</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='muestras__container d-flex flex-column align-items-start'>
                                                {dataMuestras.map((m, i) => (
                                                    <div key={i} className='eachMuestras'>
                                                            <img className='arrow me-2' src={Arrow} alt='' />
                                                            {(user?.puesto <= 3) && (
                                                                <>
                                                                    <button onClick={()=>editarMuestra(m.id_muestra_norma)} className='btn__edit d-flex flex-column align-items-center justify-content-center btn bg-success rounded-circle text-white'>
                                                                        <i className="bi bi-pencil"></i>
                                                                    </button>
                                                                </>
                                                            )}
                                                            {/* ICONO */}
                                                            {(m.tipo === 1) && <i className="btn__type bi bi-file-earmark-text text-primary"></i>}
                                                            {(m.tipo === 2) && <i className="btn__type bi bi-link-45deg text-primary"></i>}
                                                            {(m.tipo === 3) && <i className="btn__type bi bi-pencil text-primary"></i>}
                                                            {/* TIPO DE MUESTRA */}
                                                            {(m.tipo === 1) && <div className='type__container'><a className='texto__truncado' href={`${API_URL}/archivos/${m.descripcion}`} target='_blank' rel="noreferrer">{m.descripcion}</a></div>}
                                                            {(m.tipo === 2) && <div className='type__container'><a className='texto__truncado' href={m.descripcion} target='_blank' rel="noreferrer">{m.descripcion}</a></div>}
                                                            {(m.tipo === 3) && (
                                                                <div className='type__container d-flex flew-row align-items-center'>
                                                                    <p className='texto__truncado p-0 m-0'>{m.descripcion}</p>
                                                                    <button onClick={()=>showText(m.id_muestra_norma)} className='btn__verMas fw-semibold btn p-0 m-0 text-blue-500 fst-italic'>Ver más</button>
                                                                </div>
                                                            )}
                                                            {/* TIPO DE ESTADO */}
                                                            {m.estado === 1 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-blue-700"><span>Subido</span></div>}
                                                            {m.estado === 2 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-warning"><span>En revisión</span></div>}
                                                            {m.estado === 3 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-success"><span>Aprobado</span></div>}
                                                            {m.estado === 4 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-danger"><span>Rechazado</span></div>}
                                                            {m.estado === 5 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-purple-600"><span>Reenviado</span></div>}
                                                            {m.estado === 6 && <div className="btn__estado d-flex flex-row align-items-center justify-content-center px-2 py-1 rounded-pill fw-medium text-white bg-dark"><span>Eliminado</span></div>}
                                                            {((user?.puesto === 1 || user?.puesto === 2 || user?.puesto === 6) && (m.estado === 1 || m.estado === 5)) && (
                                                                <button onClick={()=>showModalVerificar(m.id_muestra_norma)} className='btn__verificar btn btn-sm border border-0 d-flex flex-row align-items-center px-2 py-1 fw-medium rounded-pill'>
                                                                    <span>
                                                                        <i className="bi bi-check2 me-1"></i>
                                                                        verificar
                                                                    </span>
                                                                </button>
                                                            )}
                                                            {m.estado === 2 && (
                                                                <>
                                                                    <OverlayTrigger 
                                                                        key="top" 
                                                                        placement='top'
                                                                        overlay={
                                                                            <Tooltip id='tooltip-top'>
                                                                                {m.Resoluciones[m.Resoluciones.length - 1].texto}
                                                                            </Tooltip>
                                                                        }
                                                                    >
                                                                        <button className="btn flex items-center">
                                                                            <i className="bi bi-exclamation-circle text-danger"></i>
                                                                        </button>
                                                                    </OverlayTrigger>
                                                                </>
                                                            )}
                                                            <p className='text__fecha m-0'>{(m.fecha_creacion.slice(0,10)).replace(/-/g, '/').split("/").reverse().join("/")}</p>
                                                    
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        {(user?.puesto <= 3) && (
                                            <div className='position-relative d-inline-block' ref={menuRef}>
                                                <button onClick={() => setOpen(!open)} className='btn__newMuestra btn btn-primary btn-sm rounded-pill px-3 ms-4 fw-medium'>+ agregar evidencia</button>
                                                {open && (
                                                    <div className='position-absolute menu rounded-3 bg-white'>
                                                        <ul className='list-unstyled p-0 m-0'>
                                                            <li>
                                                                <button className='d-flex flex-row menu__btn btn px-3 py-2 w-100' onClick={()=>handleModal(1)}><i className="bi bi-file-earmark-text me-2 text-primary"></i> Archivo</button>
                                                            </li>
                                                            <li>
                                                                <button className='d-flex flex-row menu__btn btn px-3 py-2 w-100' onClick={()=>handleModal(2)}><i className="bi bi-link-45deg me-2 text-primary"></i> Link</button>
                                                            </li>
                                                            <li>
                                                                <button className='d-flex flex-row menu__btn btn px-3 py-2 w-100' onClick={()=>handleModal(3)}><i className="bi bi-pencil me-2 text-primary"></i> Texto</button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                    }
                                </>
                            )}
                        </>
                    )}
                </div>
            </muestraContext.Provider>
        </>
    )
}

export default Muestras